import { IInternationalization } from './internationalization';
import { IProviderLinks } from './provider';
import { AddressFieldData } from './select-dropdown';
import { IWidgetSettingsFormData } from './Widget/settings';
import {
  SmartBusinessSignupData,
  SmartBusinessSignupDataResponse
} from './smart-business-signup';

export enum EBusinessOnboardingFlow {
  AUTHENTICATED_HAVE_BUSINESS = 'authenticated_have_business'
}

export enum EBusinessOnboardingInitialFlow {
  DIRECT_LINK = 'direct-link',
  PROVIDER = 'provider'
}

export interface BusinessOnboardingAccountForm {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface BusinessOnboardingYourStoreForm {
  country: IInternationalization;
  operationType: string;
}

export interface BusinessOnboardingNavLink {
  label: string;
  path: string;
  key: string;
}

export interface BusinessOnboardingStoreDetailsForm {
  providerConnection: {
    provider: string;
    link: string;
    links?: IProviderLinks;
  };
  address: AddressFieldData | null;
  aditionalAddress: string;
  merchantId: string;
  website: string;
  businessName: string;
  locationName: string;
  phone: {
    code: string;
    iso: string;
    number: string;
  };
  subCategories?: string[];
  confirmed?: boolean;
  businessLeadId?: string;
}

export interface BusinessOnboardingYourBusinessCategoryForm {
  selectedCategory: {
    id: string;
    otherValue: string;
  };
}

export interface ImageFile {
  imageFile?: Blob;
  imageUrl: string;
  imageName: string;
}

export interface BusinessOnboardingYourDigitalCoinsForm {
  color: string;
  colorKey: string;
  coinName: string;
  coinShowFront: boolean;
  isLoadingImg: boolean;
  recaptcha?: string;
  image?: ImageFile;
  isOauthImage?: boolean;
  coinFrontImgUrlSaved?: string;
}

export interface BusinessOnboardingLink {
  label: string;
  path: string;
  key: string;
  routes: string[];
}

export interface BusinessOnboardingState {
  flow?: EBusinessOnboardingFlow;
  prefilledBusinessId?: string;
  createdAccount?: boolean;
  navLinks: BusinessOnboardingNavLink[];
  yourDigitalCoin: {
    form: BusinessOnboardingYourDigitalCoinsForm;
  };
  account: {
    form: BusinessOnboardingAccountForm;
  };
  yourStore: {
    form: BusinessOnboardingYourStoreForm;
  };
  storeDetails: {
    form: BusinessOnboardingStoreDetailsForm;
  };
  yourBusinessCategory: {
    categories: Array<{ label: string; value: string }>;
    form: BusinessOnboardingYourBusinessCategoryForm;
  };
  loyaltyWidget: {
    form: IWidgetSettingsFormData;
  };
  smartBusinessSignup: Partial<SmartBusinessSignupData>;
  generatedSmartBusinessResponse: Partial<SmartBusinessSignupDataResponse>;
}
